import React from "react";
import { Outlet } from "react-router-dom";
import ProtectedRoute from "routes/ProtectedRoute";

const presentationRoutes = [
  // Admin: presentation details
  {
    path: "presentation-details/:presentationId",
    lazy: async () => {
      const mod = await import("views/Admin/Presentation/PresentationDetails");
      const PresentationDetails = mod.default ;

      return {
        Component: () => (
          <ProtectedRoute>
            <PresentationDetails />
          </ProtectedRoute>
        ),
      };
    },
  },

  // Admin: active presentation (with optional eventId)
  {
    path: "active-presentation/:urlPresentationId/:eventId?",
    lazy: async () => {
      const mod = await import("views/Admin/ActivePresentation");
      const ActivePresentation = mod.default;

      return {
        Component: () => (
          <ProtectedRoute>
            <ActivePresentation />
          </ProtectedRoute>
        ),
      };
    },
  },

  // External group
  {
    path: "/external",
    lazy: async () => {
      const errorMod = await import("views/ErrorPage");
      const ErrorPage = errorMod.default;

      // Parent provides error boundary; children lazy-load pages
      return {
        Component: () => <Outlet />,
        ErrorBoundary: ErrorPage,
      };
    },
    children: [
      {
        index: true,
        lazy: async () => {
          const mod = await import("views/external-files/presentation/ex-landing");
          const ExLandingPage = mod.default;
          return { Component: ExLandingPage };
        },
      },
      {
        path: "active-presentation/:urlPresentationId",
        lazy: async () => {
          const mod = await import(
            "views/external-files/presentation/ex-activepresentation"
          );
          const ExternalActivePresentation = mod.default;

          return {
            Component: () => (
              <ProtectedRoute>
                <ExternalActivePresentation />
              </ProtectedRoute>
            ),
          };
        },
      },
    ],
  },

  // Admin: active event
  {
    path: "active-event/:eventId/:teamId",
    lazy: async () => {
      const mod = await import("views/Admin/ActivePresentation");
      const ActivePresentation = mod.default;

      return {
        Component: () => (
          <ProtectedRoute>
            <ActivePresentation />
          </ProtectedRoute>
        ),
      };
    },
  },

  // Admin: preview event
  {
    path: "preview-event/:presentationId",
    lazy: async () => {
      const mod = await import("views/Admin/ActivePresentation");
      const ActivePresentation = mod.default;

      return {
        Component: () => (
          <ProtectedRoute>
            <ActivePresentation />
          </ProtectedRoute>
        ),
      };
    },
  },

  // Test group
  {
    path: "/test",
    lazy: async () => {
      const errorMod = await import("views/ErrorPage");
      const ErrorPage = errorMod.default;
      return {
        Component: () => <div />, // placeholder outlet container (see NOTE below)
        ErrorBoundary: ErrorPage,
      };
    },
    children: [
      {
        path: "preview-presentation",
        lazy: async () => {
          const mod = await import("components/UI/mobile/previewPresentation");
          const PreviewPresentationMobile = mod.default;
          return { Component: PreviewPresentationMobile };
        },
      },
      {
        path: "presentation",
        lazy: async () => {
          const mod = await import("components/UI/mobile/mobilePresentation");
          // @ts-ignore
          const MobilePresentation =  mod.MobilePresentation;
          return { Component: MobilePresentation };
        },
      },
    ],
  },
];

export default presentationRoutes;
